const TILES = [
  { key: 'total', label: 'Всего заявок' },
  { key: 'approved', label: 'Одобренные' },
  { key: 'asp', label: 'АСП' },
  { key: 'repeat', label: 'Повторные' },
];

const format = (value) =>
  value === null || value === undefined ? '—' : value.toLocaleString('ru-RU');

export default function RegistrationTimelineTotals({ totals, peak, range }) {
  return (
    <div className='flex flex-col gap-2'>
      <div className='grid grid-cols-2 gap-2 md:grid-cols-4'>
        {TILES.map((tile) => (
          <div key={tile.key} className='rounded-md bg-white p-4 shadow-sm'>
            <div className='text-xs uppercase tracking-wide text-secondary'>
              {tile.label}
            </div>
            <div className='mt-1 text-2xl font-bold text-gray-900'>
              {format(totals?.[tile.key])}
            </div>
          </div>
        ))}
      </div>

      {/* The one-line answer to "в какое время больше всего регистрировались". */}
      <div className='rounded-md border-l-4 border-primary bg-white p-4 shadow-sm'>
        <div className='text-xs uppercase tracking-wide text-secondary'>Пик</div>
        {peak ? (
          <div className='mt-1 text-lg font-bold text-gray-900'>
            {peak.label} — {format(peak.value)}{' '}
            <span className='font-normal text-secondary'>
              ({peak.seriesName})
            </span>
          </div>
        ) : (
          <div className='mt-1 text-lg text-secondary'>Нет данных</div>
        )}
        {range?.from && range?.to && (
          <div className='mt-1 text-xs text-secondary'>
            Данные за период {range.from} — {range.to}
          </div>
        )}
      </div>
    </div>
  );
}
